export const USER_POOL_ID="us-east-1_JD4mXIgJB";
export const CLIENT_ID="4lr70t4i8m22oqjuldguv7dl6q";
export const AWS_REGION = "us-east-1";
export const TOKEN="oidc.user:https://cognito-idp.us-east-1.amazonaws.com/us-east-1_JD4mXIgJB:4lr70t4i8m22oqjuldguv7dl6q";
export const SIGNOUT_URI="sa-5762-client-file-upload-tool-prod/logout?response_type=code&client_id=4lr70t4i8m22oqjuldguv7dl6q&redirect_uri=https://sa-file-upload.thetradedesk.com/loginCallback";
export const API_GATEWAY_ENDPOINT="https://sa-file-upload.thetradedesk.com/fileUpload/v2";
export const ADMIN_GROUP_NAME = "sa_5762_client_file_upload_ttd_admins";
export const DEV_GROUP_NAME = "sa_5762_client_file_upload_devs";